<div class="quick-nav">
  <lg-select-field [block]="block">
    <select
      (change)="handleOptionChange($any($event).target.value)"
      aria-label="quick navigation"
      formControlName="Quick nav"
      lgSelect
      name="quick navigation"
    >
      <option>Please select</option>
      @for (option of options; let i = $index; track i) {
        <option [value]="option['href']">
          {{ option["text"] }}
        </option>
      }
    </select>
  </lg-select-field>
  <a
    (click)="interactionClickEvent(quickNavTarget, 'Continue button')"
    [href]="quickNavTarget"
    [iconButton]="true"
    [ngClass]="isDisabled ? 'disabled' : ''"
    aria-label="continue"
    lg-button
    type="button"
  >
    <lg-icon name="arrow-right" />
  </a>
</div>
